import React from 'react';

import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import ClassOutlinedIcon from '@material-ui/icons/ClassOutlined';
import { capitalize } from 'utils';

import styles from './styles.module.scss';

const StudentSubtitle = ({ studentName, sectionLabel }) => {
  if (!studentName && !sectionLabel) return null;

  return (
    <div className={styles.navSubtitleContainer}>
      {studentName && (
        <div className={styles.navSubtitleGroup}>
          <AccountCircleOutlinedIcon className={styles.navSubtitleIcon} />
          <span className={styles.studentNameText}>
            {capitalize({ str: studentName })}
          </span>
        </div>
      )}
      {sectionLabel && (
        <div className={styles.navSubtitleGroup}>
          <ClassOutlinedIcon className={styles.navSubtitleIcon} />
          <span className={styles.sectionLabelText}>{sectionLabel}</span>
        </div>
      )}
    </div>
  );
};

export default StudentSubtitle;
